define('components/decorators/tooltip',[
  'jquery'
],function($) {
  /*
   * -- EXAMPLE --
   * <div data-decorator="ci-tooltip">
   *   <div>some content</div>
   *
   *   <div data-tooltip-trigger>
   *     <div>some content</div>
   *     <div class='hidden' data-tooltip-content>
   *       Tooltip content
   *     </div>
   *   </div>
   *
   * </div>
   * */

  $.extend(companyInfo.decorators, {
    'ci-tooltip': function () {
      var $tooltipEls = $('[data-tooltip-trigger]', this); // Elements over which tooltip will be shown
      var $tooltip = $('.ci-tooltip');

      // Create tooltip and append to body
      function createTooltip() {
        if ($tooltip.length) return;

        $tooltip = $(
          "<div class='ci-tooltip'>" +
            "Tooltip Content" +
          "</div>"
        );
        $('body').append($tooltip);
      }

      createTooltip();

      $tooltipEls.hover(
        // Mouse enter
        function(e) {
          var $el = $(this);
          var mouseX = e.pageX;
          var mouseY = e.pageY;
          var bbox = this.getBoundingClientRect();
          var content = $el.find('[data-tooltip-content]');

          showTooltip({
            bbox: bbox,
            mouseX: mouseX,
            mouseY: mouseY
          }, content);
        },
        // Mouse leave
        function() {
          hideTooltip();
        }
      );

      $tooltipEls.parent().on('scroll', function() { // If parent is scrollable, hide tooltip while scrolling
        $tooltip.css('display', 'none');
      });

      function showTooltip(coords, content) {
        $tooltip.empty(); // Clear previous tooltip content

        content
          .clone()
          .removeClass('hidden')
          .appendTo($tooltip); // Add new content

        // Make tooltip clone and put it to 0,0 for calculating if tooltip can fit on screen
        var clone = $tooltip.clone();
        $('body').append(clone);
        clone.css({ // Reset previous left/right value so that proper width can be calculated
          'left': 0,
          'top': 0,
          'right': 'unset'
        });
        var position = clone.outerWidth() + coords.mouseX + 10 < window.innerWidth ? "left" : "right";
        clone.remove();

        var newCoords = {
          'top': (coords.bbox.top + window.pageYOffset) - $tooltip.outerHeight(),
          'opacity': 1
        };
        newCoords[position] = position === 'left' ? coords.mouseX + 10 : window.innerWidth - coords.mouseX + 10;

        $tooltip.fadeIn('fast');
        $tooltip.css(position === 'right' ? 'left' : 'right', 'unset'); // Unset the oposite position
        $tooltip.css('pointer-events', 'none'); // Fix for triggering tooltip hover while animation is in progress
        $tooltip.finish().animate(newCoords, 50, function() {
          $tooltip.css('pointer-events', 'auto');
        });
      }

      function hideTooltip() {
        $tooltip.stop().fadeOut(1000);
      }

      $tooltip.on('wheel', function(e) { // have to use wheel because tooltip is not scrollable
        e.preventDefault(); // Firefox and IE fix so that page doesn't start to scroll
        $(this).css('display', 'none');
      });

      $tooltip.hover(
        // Mouse enter
        function() {
          $(this).stop().fadeIn();
        },
        // Mouse leave
        function() {
          hideTooltip();
        }
      );
    }
  });
});

